import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { FormField } from "./FormField";

/**
 * Single-select party dropdown (farmers + suppliers).
 */
export function PartySelect({
  parties,
  value,
  onChange,
  label = "Party",
  required,
  placeholder = "Select party…",
  allowAll = false,
  allLabel = "All parties",
  disabled,
  testId = "party-select",
  className,
}) {
  const selectValue = value || (allowAll ? "all" : "_none");

  return (
    <FormField label={label} required={required} className={className}>
      <Select
        value={selectValue}
        onValueChange={(v) => {
          if (allowAll && v === "all") onChange("");
          else if (v === "_none") onChange("");
          else onChange(v);
        }}
        disabled={disabled}
      >
        <SelectTrigger data-testid={testId}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {allowAll && <SelectItem value="all">{allLabel}</SelectItem>}
          {!allowAll && (
            <SelectItem value="_none" disabled>
              {placeholder}
            </SelectItem>
          )}
          {parties.map((p) => (
            <SelectItem key={p.id} value={String(p.id)}>
              {p.display_name}
              {p.phone ? ` · ${p.phone}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
